"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../../new-components/constants");
var _Button = _interopRequireDefault(require("../../new-components/Button/Button"));
var _newComponents = require("../../new-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CookieBanner = function CookieBanner(_ref) {
  var privacyPolicyUrl = _ref.privacyPolicyUrl,
    toggleShowCookieBanner = _ref.toggleShowCookieBanner,
    showCookieBanner = _ref.showCookieBanner;
  // I added this fallback because we don't have same context on tyw/tsw repo so wouldn't work with props
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    fallbackShowBanner = _useState2[0],
    setFallbackShowBanner = _useState2[1];
  (0, _react.useEffect)(function () {
    if (_jsCookie["default"].get('hid_cookie_banner') === undefined) {
      toggleShowCookieBanner && toggleShowCookieBanner();
      setFallbackShowBanner(true);
      _jsCookie["default"].set('hid_cookie_banner', true, {
        expires: 365
      });
    }
  }, []);
  if (!showCookieBanner && !fallbackShowBanner) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cookie-banner padding-sm d8-u-black-bg relative white flex flex-center text-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE_WHITE_NO_PADDING,
    onClick: function onClick() {
      toggleShowCookieBanner && toggleShowCookieBanner();
      setFallbackShowBanner(false);
    },
    buttonSize: _constants.BUTTON_SIZES.XLARGE
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex relative padding-left-sm d8-u-color-white",
    style: {
      margin: '0 auto',
      top: -2
    }
  }, "Our website uses cookies.", /*#__PURE__*/_react["default"].createElement(_newComponents.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xs"
  }, "'Cause they're delish.")), /*#__PURE__*/_react["default"].createElement("a", {
    href: privacyPolicyUrl,
    className: "margin-left-xs",
    rel: "nofollow",
    title: "Privacy & Cookies Policy",
    style: {
      color: '#fff',
      textDecoration: 'underline'
    }
  }, ' ', "Read more")));
};
CookieBanner.propTypes = {
  privacyPolicyUrl: _propTypes["default"].string.isRequired,
  toggleShowCookieBanner: _propTypes["default"].func,
  showCookieBanner: _propTypes["default"].bool
};
var _default = exports["default"] = CookieBanner;